import { render, staticRenderFns } from "./AddDrivers.vue?vue&type=template&id=b0e886d2"
import script from "./AddDrivers.vue?vue&type=script&lang=ts"
export * from "./AddDrivers.vue?vue&type=script&lang=ts"
import style0 from "./AddDrivers.vue?vue&type=style&index=0&id=b0e886d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports